// extracted by mini-css-extract-plugin
export default {"GlobalSearchResults":"index__GlobalSearchResults__xBhLG","container":"index__container__Lirwu","NoResultsSearchIcon":"index__NoResultsSearchIcon__t7073"};